/*
 * RequestForm Messages
 *
 * This contains all the text for the RequestForm component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.RequestForm.header',
    defaultMessage: 'Request for Leave',
  },
  studentIds: {
    id: 'app.components.RequestForm.studentIds',
    defaultMessage: 'Request Leave for',
  },
  explanation: {
    id: 'app.components.RequestForm.explanation',
    defaultMessage: 'Explanation',
  },
  explanationPlaceholder: {
    id: 'app.components.RequestForm.explanationPlaceholder',
    defaultMessage: 'Optionally provide a brief explanation',
  },
  explanationOtherPlaceholder: {
    id: 'app.components.RequestForm.explanationOtherPlaceholder',
    defaultMessage: 'Provide a brief explanation',
  },
  period: {
    id: 'app.components.RequestForm.period',
    defaultMessage: 'Leave Period',
  },
  lateExplanation: {
    id: 'app.components.RequestForm.lateExplanation',
    defaultMessage: 'Reason for late request',
  },
  lateExplanationPlaceholder: {
    id: 'app.components.RequestForm.lateExplanationPlaceholder',
    defaultMessage: 'What is the reason that the request had not been submitted earlier?',
  },
  reportType: {
    id: 'app.components.RequestForm.reportType',
    defaultMessage: 'Reason for Leave',
  },
  selectReason: {
    id: 'app.components.RequestForm.selectReason',
    defaultMessage: 'Select a Reason',
  },
  requestBefore: {
    id: 'app.components.RequestForm.requestBeforeDays',
    defaultMessage: 'Your request should be submitted at least {num} {unit, select, d {days} w {weeks} other {??}} before the leave',
  },
  submitRequest: {
    id: 'app.components.RequestForm.submitRequest',
    defaultMessage: 'Request',
  },
  employmentType: {
    id: 'app.components.RequestForm.employmentType',
    defaultMessage: 'Employment',
  },
  emplEntrepreneur: {
    id: 'app.components.RequestForm.emplEntrepreneur',
    defaultMessage: 'Entrepreneur',
  },
  emplEmployed: {
    id: 'app.components.RequestForm.emplEmployed',
    defaultMessage: 'Paid Employment',
  },
  employedHelp: {
    id: 'app.components.RequestForm.employedHelp',
    defaultMessage: 'You need an <a>Employers Statement</a>. It must be completed by the employer. You can scan the document and submit with this request or hand it over at your school.',
  },
  document: {
    id: 'app.components.RequestForm.document',
    defaultMessage: 'Employers Statement',
  },
  handover: {
    id: 'app.components.RequestForm.handover',
    defaultMessage: 'I will hand over the document at the school',
  },
  download: {
    id: 'app.components.RequestForm.download',
    defaultMessage: 'Download form',
  },
  select: {
    id: 'app.components.RequestForm.select',
    defaultMessage: 'Select',
  },
  upload: {
    id: 'app.components.RequestForm.upload',
    defaultMessage: 'Upload form',
  },
  save: {
    id: 'app.common.save',
    defaultMessage: 'Save',
  },
  request: {
    id: 'app.components.RequestForm.request',
    defaultMessage: 'Request',
  },
  saved: {
    id: 'app.components.RequestForm.saved',
    defaultMessage: 'The request has been saved',
  },
  requested: {
    id: 'app.components.RequestForm.requested',
    defaultMessage: 'The request has been submitted',
  },
  companyInfo: {
    id: 'app.components.RequestForm.companyInfo',
    defaultMessage: 'Company',
  },
  checkOrUpload: {
    id: 'app.components.RequestForm.checkOrUpload',
    defaultMessage: 'Check the box or upload a document',
  },
});
